import React, { useEffect, useState } from 'react'

const calculateTimeLeft = (futureDateTime: string) => {
    const expiration = new Date(futureDateTime)
    const timeLeft = expiration.getTime() - new Date().getTime()
    return timeLeft < 0 ? 0 : timeLeft
}

const formatTime = (timeLeft: number) => {
    let seconds = Math.floor(timeLeft / 1000)
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    seconds = seconds % 60

    return `${hours}h ${minutes}m ${seconds}s`
}

const CountdownClock = ({ futureDateTime }) => {
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(futureDateTime))

    useEffect(() => {
        const intervalId = setInterval(() => {
            setTimeLeft(calculateTimeLeft(futureDateTime))
        }, 1000)

        return () => clearInterval(intervalId)
    }, [futureDateTime])

    return (
        <div className="countdown bottom center">
            <h1>
                <span>{formatTime(timeLeft)}</span>
            </h1>
        </div>
    )
}

export default CountdownClock
